module.exports = __webpack_public_path__ + "img/04.8316311d.png";